import { render, staticRenderFns } from "./ControlsContainer.vue?vue&type=template&id=074b92b9&scoped=true&"
import script from "./ControlsContainer.vue?vue&type=script&lang=ts&"
export * from "./ControlsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ControlsContainer.vue?vue&type=style&index=0&id=074b92b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074b92b9",
  null
  
)

export default component.exports